import { Col, DatePicker, Form, Row, Space, Typography } from 'antd';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

type ExportExtentionInfoProps = {
  editable: boolean;
  status: string | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  form: any;
  exportExtentionData: any;
  editableUser?: boolean;
  updateConfig?: boolean;
};

const ExportExtentionInfo: React.FC<ExportExtentionInfoProps> = ({
  editable,
  form,
  exportExtentionData,
  editableUser,
  updateConfig,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (exportExtentionData) {
      console.log('Export Extension Data:', exportExtentionData);
    }
  }, [exportExtentionData]);

  const fields: any = [
    {
      name: 'code',
      label: 'Extension Code',
      component: <BaseInput readOnly />,
    },
    {
      name: 'export_code',
      label: 'Export Code',
      component: (
        <BaseInput
          readOnly
          style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}
          onClick={() => navigate('/view-export', { state: { id: exportExtentionData?.export_id } })}
        />
      ),
    },
    {
      name: 'ext_no',
      label: 'Extension Number',
      component: <BaseInput readOnly />,
    },
    {
      name: 'prv_ext_id',
      label: 'Previous Extension ID',
      component: <BaseInput readOnly />,
    },
    {
      name: 'request_date',
      label: 'Request Date',
      noFormBind: !(editable && editableUser),
      component:
        editable && editableUser ? (
          <DatePicker
            format="DD MMM YYYY"
            style={{ width: '100%' }}
            disabledDate={(current) => current && current.isBefore(moment(), 'day')}
          />
        ) : (
          <BaseInput
            readOnly
            value={
              exportExtentionData?.request_date ? moment(exportExtentionData.request_date).format('DD MMM YYYY') : ''
            }
          />
        ),
    },
    {
      name: 'expire_date',
      label: 'Expiration Date',
      noFormBind: !(editable && updateConfig),
      extra:
        editable && updateConfig ? (
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            Please set a date ahead of today (e.g. at least 1 month from now).
          </Typography.Text>
        ) : undefined,
      component:
        editable && updateConfig ? (
          <DatePicker
            format="DD MMM YYYY"
            style={{ width: '100%' }}
            disabledDate={(current) => current && current.isBefore(moment(), 'day')}
          />
        ) : (
          <BaseInput
            readOnly
            value={
              exportExtentionData?.expire_date ? moment(exportExtentionData.expire_date).format('DD MMM YYYY') : ''
            }
          />
        ),
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {fields?.map((e: any) => (
        <React.Fragment key={e.name}>
          <Col xs={24} md={12}>
            <Form.Item
              name={e?.noFormBind ? undefined : e?.name}
              label={<Space style={{ display: 'flex', alignItems: 'center' }}>{e?.label}</Space>}
              extra={e?.extra}
            >
              {e?.component}
            </Form.Item>
          </Col>
        </React.Fragment>
      ))}
    </Row>
  );
};

export default ExportExtentionInfo;
